import { NgModule } from '@angular/core';
import { InputTextModule } from '@openng/optimus-ui/inputtext';

import { PrimeInputTextDefaultMaxlengthDirective } from './prime-input-text-default-maxlength.directive';

@NgModule({
  imports: [InputTextModule, PrimeInputTextDefaultMaxlengthDirective],
  exports: [InputTextModule, PrimeInputTextDefaultMaxlengthDirective],
})
export class NxInputTextModule {}
